import React from 'react';
import { SVGS } from '../assets/images'
import {IAppRouter} from './interfaces/IAppRouter'
import SchedulePage from '../pages/Schedule';
import TimeReportV2Page from '../pages/TimeReportV2';
import TimeBankReportPage from '../pages/TimeBankReport';
import CreateTimeBankManualTransactionPage from '../pages/TimeBankReport/create-manual-transaction';
import VacationReportPage from '../pages/VacationReport';
import CreateVacationPage from '../pages/VacationReport/components/create-vacation';
import EditVacationPage from '../pages/VacationReport/components/edit-vacation';
import RolesPage from '../pages/Roles';
import EmployeesPage from '../pages/Empoyees';
import ClientPage from '../pages/Clients';
import ProjectsPage from '../pages/Projects';
import SettingsPage from '../pages/Settings';
import SettingsPreferencesPage from '../pages/Settings/components/preferences';
import SettingsIntegrationsPage from '../pages/Settings/components/integrations';
import SettingsEarlyAccessPage from '../pages/Settings/components/early-access';
import SettingsCalendarPage from '../pages/Settings/components/work-calendar';
import CreateWorkCalendarForm from '../pages/Settings/components/work-calendar/components/calendar/create-calendar';
import EditWorkCalendarForm from '../pages/Settings/components/work-calendar/components/calendar/edit-calendar';
import EditWorkCalendarDayForm from '../pages/Settings/components/work-calendar/components/day/edit-day';
import ZohoIntegrationConfigurationPage from '../pages/Settings/components/integrations/components/integrations/zoho/zoho-configuration-page';
import ProfilePage from '../pages/Profile';
import ProjectTypeEditForm from '../pages/Types/components/project-types/components/edit-project-type';
import CostReportPage from '../pages/CostReport';
import ProjectTypes from '../pages/Types/components/project-types';
import ShiftTypes from '../pages/Types/components/shift-types';
import AbsencesTypes from '../pages/Types/components/absences-types';
import ProjectTypeCreateForm from '../pages/Types/components/project-types/components/create-project-type';
import ShiftTypeEditForm from '../pages/Types/components/shift-types/components/edit-shift-type';
import ShiftTypeCreateForm from '../pages/Types/components/shift-types/components/create-shift-type';
import AbsenceTypeCreateForm from '../pages/Types/components/absences-types/components/create-absence-type';
import AbsenceTypeEditForm from '../pages/Types/components/absences-types/components/edit-absence-type';
import { NAVIGATION_ROUTES } from './NavigationRoute';
import TypesPage from '../pages/Types';
import TagTypes from '../pages/Types/components/tags-types';
import TagTypeCreateForm from '../pages/Types/components/tags-types/components/create-tag-type';
import RoleCreateForm from '../pages/Roles/components/create-role';
import RoleEditForm from '../pages/Roles/components/edit-role';
import CreateClientForm from '../pages/Clients/components/create-client';
import EditClientForm from '../pages/Clients/components/edit-client';
import CreateCostForm from '../pages/CostReport/components/modals/create-cost';
import EditCostForm from '../pages/CostReport/components/modals/edit-cost';
import CreateEmployeeForm from '../pages/Empoyees/components/create-employee';
import EditEmployeeForm from '../pages/Empoyees/components/edit-employee';
import CreateProjectForm from '../pages/Projects/components/create-project';
import EditProjectForm from '../pages/Projects/components/edit-project';
import CreateShiftPage from '../pages/Shift/create-shift';
import EditShiftPage from '../pages/Shift/edit-shift';
import EditAbsencePage from '../pages/Shift/edit-absence';
import ProfilePaymentMethodsPage from '../pages/Profile/components/payment-methods';
import ProfileSubscriptionPage from '../pages/Profile/components/subscrption';
import ProfileInfoPage from '../pages/Profile/components/profile-info';
import ProfileProjectsPage from '../pages/Profile/components/profile-projects';
import ProfileRolesPage from '../pages/Profile/components/profile-roles';
import TimeTrackingImportPage from '../pages/TimeTrackingImport';
import FavoriteFiltersPage from '../pages/FavoriteFilters';

const ROUTES: IAppRouter = {
    main: NAVIGATION_ROUTES.MAIN,
    login: '/auth',
    linkProceed: '/user/email-magic-link',
    logout: {
        name: 'Logout',
        url: '/logout',
    },
    types: {
        name: 'types',
        url: NAVIGATION_ROUTES.TYPES,
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.TypesIcon />,
        element: <TypesPage />
    },
    roles: {
        name: 'roles',
        url: NAVIGATION_ROUTES.ROLES,
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.RolesIcon />,
        element: <RolesPage />
    },
    employees: {
        name: 'employees',
        url: NAVIGATION_ROUTES.EMPLOYEES,
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.EmployeesIcon />,
        element: <EmployeesPage />
    },
    createEmployee: {
        name: 'createEmployee',
        url: NAVIGATION_ROUTES.CREATE_EMPLOYEE,
        element: <CreateEmployeeForm />,
    },
    editEmployee: {
        name: 'editEmployee',
        url: NAVIGATION_ROUTES.EDIT_EMPLOYEE,
        element: <EditEmployeeForm />,
    },
    clients: {
        name: 'clients',
        url: NAVIGATION_ROUTES.CLIENTS,
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.ClientsIcon />,
        element: <ClientPage />
    },
    createClient: {
        name: 'createClient',
        url: NAVIGATION_ROUTES.CREATE_CLIENT,
        element: <CreateClientForm />,
    },
    editClient: {
        name: 'editClient',
        url: NAVIGATION_ROUTES.EDIT_CLIENT,
        element: <EditClientForm />,
    },
    projects: {
        name: 'projects',
        url: NAVIGATION_ROUTES.PROJECTS,
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.ProjectsIcon />,
        element: <ProjectsPage />
    },
    projectsByType: {
        name: 'projectsByType',
        url: NAVIGATION_ROUTES.PROJECTS_BY_TYPE,
        element: <ProjectsPage />,
    },
    createProject: {
        name: 'createProject',
        url: NAVIGATION_ROUTES.CREATE_PROJECT,
        element: <CreateProjectForm />,
    },
    editProject: {
        name: 'editProject',
        url: NAVIGATION_ROUTES.EDIT_PROJECT,
        element: <EditProjectForm />,
    },
    settings: {
        name: 'settings',
        url: '/settings',
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.SettingsIcon />,
        element: <SettingsPage />
    },
    settingsPreferences: {
        name: 'settingsPreferences',
        url: NAVIGATION_ROUTES.SETTINGS_PREFERENCES,
        element: <SettingsPreferencesPage />,
    },
    settingsIntegrations: {
        name: 'settingsIntegrations',
        url: NAVIGATION_ROUTES.SETTINGS_INTEGRATIONS,
        element: <SettingsIntegrationsPage />,
    },
    settingsIntegrationsZohoEdit: {
        name: 'settingsIntegrationsZohoEdit',
        url: NAVIGATION_ROUTES.SETTINGS_INTEGRATIONS_ZOHO_EDIT,
        element: <ZohoIntegrationConfigurationPage />,
    },
    settingsEarlyAccess: {
        name: 'settingsEarlyAccess',
        url: NAVIGATION_ROUTES.SETTINGS_EARLY_ACCESS,
        element: <SettingsEarlyAccessPage />,
    },
    settingsCalendar: {
        name: 'settingsCalendar',
        url: NAVIGATION_ROUTES.SETTINGS_CALENDAR,
        element: <SettingsCalendarPage />,
    },
    settingsCalendarCreate: {
        name: 'settingsCalendarCreate',
        url: NAVIGATION_ROUTES.SETTINGS_CALENDAR_CREATE,
        element: <CreateWorkCalendarForm />,
    },
    settingsCalendarEdit: {
        name: 'settingsCalendarEdit',
        url: NAVIGATION_ROUTES.SETTINGS_CALENDAR_EDIT,
        element: <EditWorkCalendarForm />,
    },
    settingsCalendarDayEdit: {
        name: 'settingsCalendarDayEdit',
        url: NAVIGATION_ROUTES.SETTINGS_CALENDAR_DAY_EDIT,
        element: <EditWorkCalendarDayForm />,
    },
    schedule: {
        name: 'schedule',
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.AddChartIcon />
    },
    timesheet: {
        name: 'timesheet',
        url: NAVIGATION_ROUTES.TIMESHEET,
        element: <SchedulePage />,
    },
    timesheetImport: {
        name: 'timesheet_import',
        url: NAVIGATION_ROUTES.TIMESHEET_IMPORT,
        element: <TimeTrackingImportPage />,
    },
    timesheetFavorites: {
        name: 'timesheet_favorites',
        url: NAVIGATION_ROUTES.TIMESHEET_FAVORITES,
        // eslint-disable-next-line react/react-in-jsx-scope
        element: <FavoriteFiltersPage scope='Timesheet' />,
    },
    createShift: {
        name: 'create_shift',
        url: NAVIGATION_ROUTES.CREATE_SHIFT,
        element: <CreateShiftPage />,
    },
    editShift: {
        name: 'edit_shift',
        url: NAVIGATION_ROUTES.EDIT_SHIFT,
        element: <EditShiftPage />,
    },
    editAbsence: {
        name: 'edit_absence',
        url: NAVIGATION_ROUTES.EDIT_ABSENCE,
        element: <EditAbsencePage />,
    },
    timereport: {
        name: 'timereport',
        url: NAVIGATION_ROUTES.TIMEREPORT,
        element: <TimeReportV2Page />,
    },
    timebankreport: {
        name: 'timebankreport',
        url: NAVIGATION_ROUTES.TIMEBANKREPORT,
        element: <TimeBankReportPage />,
    },
    timereportFavorites: {
        name: 'timereport_favorites',
        url: NAVIGATION_ROUTES.TIMEREPORT_FAVORITES,
        // eslint-disable-next-line react/react-in-jsx-scope
        element: <FavoriteFiltersPage scope='TimeReport' />,
    },
    createTimeBankTransaction: {
        name: 'timebankreport_manual_transaction',
        url: NAVIGATION_ROUTES.CREATE_TIME_BANK_TRANSACTION,
        element: <CreateTimeBankManualTransactionPage />,
    },
    vacationreport: {
        name: 'vacation_report',
        url: NAVIGATION_ROUTES.VACATIONREPORT,
        element: <VacationReportPage />,
    },
    createVacation: {
        name: 'create_vacation',
        url: NAVIGATION_ROUTES.CREATE_VACATION,
        element: <CreateVacationPage />,
    },
    editVacation: {
        name: 'edit_vacation',
        url: NAVIGATION_ROUTES.EDIT_VACATION,
        element: <EditVacationPage />,
    },
    costreport: {
        name: 'costreport',
        url: NAVIGATION_ROUTES.COSTREPORT,
        element: <CostReportPage />,
    },
    createCost: {
        name: 'createCost',
        url: NAVIGATION_ROUTES.CREATE_COST,
        element: <CreateCostForm />,
    },
    editCost: {
        name: 'editCost',
        url: NAVIGATION_ROUTES.EDIT_COST,
        element: <EditCostForm />,
    },
    zoho: '/zoho',

    projectTypes: {
        name: 'projectTypes',
        url: NAVIGATION_ROUTES.PROJECT_TYPES,
        element: <ProjectTypes />,
    },

    editProjectType: {
        name: 'editProjectType',
        url: NAVIGATION_ROUTES.EDIT_PROJECT_TYPE,
        element: <ProjectTypeEditForm />,
    },

    createProjectType: {
        name: 'createProjectType',
        url: NAVIGATION_ROUTES.CREATE_PROJECT_TYPE,
        element: <ProjectTypeCreateForm />,
    },

    shiftTypes: {
        name: 'shiftTypes',
        url: NAVIGATION_ROUTES.SHIFT_TYPES,
        element: <ShiftTypes />,
    },

    editShiftType: {
        name: 'editShiftType',
        url: NAVIGATION_ROUTES.EDIT_SHIFT_TYPE,
        element: <ShiftTypeEditForm />,
    },

    createShiftType: {
        name: 'createShiftType',
        url: NAVIGATION_ROUTES.CREATE_SHIFT_TYPE,
        element: <ShiftTypeCreateForm />,
    },

    absenceTypes: {
        name: 'absenceTypes',
        url: NAVIGATION_ROUTES.ABSENCE_TYPES,
        element: <AbsencesTypes />,
    },

    editAbsenceType: {
        name: 'editAbsenceType',
        url: NAVIGATION_ROUTES.EDIT_ABSENCE_TYPE,
        element: <AbsenceTypeEditForm />,
    },

    createAbsenceType: {
        name: 'createAbsenceType',
        url: NAVIGATION_ROUTES.CREATE_ABSENCE_TYPE,
        element: <AbsenceTypeCreateForm />
    },

    tagTypes: {
        name: 'tagTypes',
        url: NAVIGATION_ROUTES.TAG_TYPES,
        element: <TagTypes />,
    },

    createTagType: {
        name: 'createTagType',
        url: NAVIGATION_ROUTES.CREATE_TAG_TYPE,
        element: <TagTypeCreateForm />
    },

    editRole: {
        name: 'editRole',
        url: NAVIGATION_ROUTES.EDIT_ROLE,
        element: <RoleEditForm />
    },

    createRole: {
        name: 'createRole',
        url: NAVIGATION_ROUTES.CREATE_ROLE,
        element: <RoleCreateForm />
    },
    profile: {
        name: 'profile',
        url: '/',
        // eslint-disable-next-line react/react-in-jsx-scope
        svg: <SVGS.ProfileIcon />,
        element: <ProfilePage />
    },
    profilePaymentMethods: {
        name: 'profilePaymentMethods',
        url: NAVIGATION_ROUTES.PROFILE_PAYMENT_METHODS,
        element: <ProfilePaymentMethodsPage />,
    },
    profileSubscription: {
        name: 'profilePaymentMethods',
        url: NAVIGATION_ROUTES.PROFILE_SUBSCRIPTION,
        element: <ProfileSubscriptionPage />,
    },
    profileInfo: {
        name: 'profilePaymentMethods',
        url: NAVIGATION_ROUTES.PROFILE,
        element: <ProfileInfoPage />,
    },
    profileProjects: {
        name: 'profileProjects',
        url: NAVIGATION_ROUTES.PROFILE_PROJECTS,
        element: <ProfileProjectsPage />,
    },
    profileRoles: {
        name: 'profileRoles',
        url: NAVIGATION_ROUTES.PROFILE_ROLES,
        element: <ProfileRolesPage />,
    },
}

export default ROUTES
